  import { DomUtils } from '@zm-biz/zm-biz-utils';
  import { NAME } from '../config';
  require('./main.scss');

  export default {
    name: NAME,

    props: {
      options: {
        type: Object,
        default: () => { return {} }
      },
      show: {
        type: Boolean,
        default: false
      }
    },

    watch: {
      show(v) {
        if (!!v) {
          DomUtils.touchDisable();
        }else {
          DomUtils.touchEable();
        }
      }
    },

    render: function (h) {

      if (this.show == false) {
        return (null);
      }

      return (
        <div class='component-loading'>
          <div class={['spinner', this.options.color || 'black']}></div>
        </div>
      )
    }
}
